import React, { useEffect, useRef, useState } from "react";
import MainService from "../helpers/services/mainService";
import { ApiService } from "../helpers/services/apiSrevice";
import { useTranslation } from "../lang/TranslationProvider";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import { useSelector } from "react-redux";
import parse from 'html-react-parser';

export default function Exhibitions() {

	const targetRef = useRef(null);
	const { itemId } = useParams();
	const { language, languages } = useSelector(state => state.language);
	const { translate } = useTranslation();
	const [exhibitionFilters, setExhibitionFilters] = useState([]);
	const [exhibitions, setExhibitions] = useState([]);
	const [pagination, setPagination] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [languageId, setLanguageId] = useState(null);
	const [pageContent, setPageContent] = useState(null);

	useEffect(() => {
		if (languages && languages.length && language) {
			setLanguageId(languages.find(item => item.isocode2 === language)?.id);
		}
	}, [languages, language]);

	useEffect(() => {
		getExhibitionFilters();
		getPageContentByKeyName();
	}, [])

	useEffect(() => {
		getExhibitions(1);
	}, [itemId])

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	}, [])

	useEffect(() => {
		const handleIntersect = (entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					getExhibitions(currentPage + 1);
				}
			});
		};
		const observer = new IntersectionObserver(handleIntersect, {
			root: null,
			rootMargin: '0px',
			threshold: 1.0,
		});
		if (targetRef.current) {
			observer.observe(targetRef.current);
		}
		return () => {
			if (targetRef.current) {
				observer.unobserve(targetRef.current);
			}
		};
	}, [currentPage, pagination, isLoading]);

	const getPageContentByKeyName = () => {
		MainService.callApi({
			api: ApiService.getPageContentByKeyName,
			data: "KEY_EXHIBITIONS",
			cb: response => {
				if (response && response.data) {
					setPageContent(response.data);
				}
			},
		});
	}

	const getExhibitionFilters = () => {
		MainService.callApi({
			api: ApiService.getExhibitionFilters,
			data: {},
			cb: (response) => {
				if (response && response.data) {
					setExhibitionFilters(response.data);
				}
			},
		});
	};

	const getExhibitions = (currentPage) => {
		const data = {
			pageNumber: currentPage,
			pageSize: 1,
		}
		if (itemId) {
			data.exhibitionType = itemId;
		}

		setIsLoading(true);
		MainService.callApi({
			api: ApiService.getExhibitions,
			data: data,
			cb: response => {
				if (response && response.data) {
					const data = { ...response.data };
					if (data.pagination) {
						setPagination(data.pagination);
					}
					if (data.pagedData && data.pagedData.length) {
						if (currentPage > 1) {
							setExhibitions([...exhibitions, ...data.pagedData]);
						} else {
							setExhibitions(data.pagedData);
						}
					} else {
						setExhibitions([]);
					}
				}
				setIsLoading(false);
				setCurrentPage(currentPage)
			},
			_finally: () => {
				setIsLoading(false);
			},
		});
	}

	return (
		<div className="cont">
			{
				pageContent ?
					<div className="main-page-bunner exhibitions-page-bunner">
						<div className="image pull-left">
							<div className="image-cont">
								{
									pageContent && pageContent.imagePaths && pageContent.imagePaths.length ?
										<img src={pageContent.imagePaths[0]} alt="image" />
										: null
								}
							</div>
						</div>
						<div className="text pull-right">
							<span className="label">{MainService.getValueByLanguageId(pageContent.titles, languageId)}</span>
							<div className="line"></div>
							<div className="name">{parse(MainService.getValueByLanguageId(pageContent.contents, languageId))}</div>
							<div className="tags">
								<div className="tags-cont">

									<Link className={`${!itemId ? "active" : ""}`} to="/exhibitions">{translate("TR_ALL")}</Link>
									{
										exhibitionFilters && exhibitionFilters.length ?
											exhibitionFilters.map((item, index) => {
												return <Link
													key={index}
													className={`${item.key === +itemId ? "active" : ""}`}
													to={`/exhibitions/${item.key}`}
												>
													{translate(item.value)}
												</Link>
											})
											: null
									}
									<div className="clear"></div>
								</div>
							</div>
							<div className="clear"></div>
						</div>
						<div className="clear"></div>
					</div>
					: null
			}
			<div className="exhibitions-list exhibitions-list-margin">
				<div className="exhibition-item-cont mobile">
					<div className="exhibition-item-cont-block" mobile_width="9600">
						{
							exhibitions && exhibitions.length ?
								exhibitions.map((item, index) => {
									return <div key={index} className="exhibition-item">
										<div className="date">
											<b>{moment(new Date(item.startDate)).format("DD.MM.YYYY")}</b>
											<span></span>
											<b>{moment(new Date(item.endDate)).format("DD.MM.YYYY")}</b>
											<div className="clear"></div>
										</div>
										<div className="image">
											<Link className="image-cont" to={`/exhibition/${item.id}`}>
												<img style={{ height: "100%" }} src={item.imagePath ? item.imagePath : "images/our-images/no-image.png"} />
											</Link>
										</div>
										<Link className="name" to={`/exhibition/${item.id}`}>
											{MainService.getValueByLanguageId(item.names, languageId)}
										</Link>
										<div className="line"></div>
										<span>{MainService.getValueByLanguageId(item.shortDescriptions, languageId)}</span>
									</div>
								})
								: null
						}
						<div className="clear"></div>
					</div>
				</div>
				<div className="column pull-left desktop">
					{
						exhibitions && exhibitions.length ?
							exhibitions.map((item, index) => {
								if (index % 2 === 0) {
									return <div key={index} className="exhibition-item">
										<div className="date">
											<b>{moment(new Date(item.startDate)).format("DD.MM.YYYY")}</b>
											<span></span>
											<b>{moment(new Date(item.endDate)).format("DD.MM.YYYY")}</b>
											<div className="clear"></div>
										</div>
										<div className="image">
											<Link className="image-cont" to={`/exhibition/${item.id}`}>
												<img style={{ height: "100%" }} src={item.imagePath ? item.imagePath : "images/our-images/no-image.png"} />
											</Link>
										</div>
										<Link className="name" to={`/exhibition/${item.id}`}>
											{MainService.getValueByLanguageId(item.names, languageId)}
										</Link>
										<div className="line"></div>
										<span>{MainService.getValueByLanguageId(item.shortDescriptions, languageId)}</span>
									</div>
								}
							})
							: null
					}
				</div>
				<div className="column pull-right column-margin-top desktop">
					{
						exhibitions && exhibitions.length ?
							exhibitions.map((item, index) => {
								if (index % 2 === 1) {
									return <div key={index} className="exhibition-item">
										<div className="date">
											<b>{moment(new Date(item.startDate)).format("DD.MM.YYYY")}</b>
											<span></span>
											<b>{moment(new Date(item.endDate)).format("DD.MM.YYYY")}</b>
											<div className="clear"></div>
										</div>
										<div className="image">
											<Link className="image-cont" to={`/exhibition/${item.id}`}>
												<img style={{ height: "100%" }} src={item.imagePath ? item.imagePath : "images/our-images/no-image.png"} />
											</Link>
										</div>
										<Link className="name" to={`/exhibition/${item.id}`}>
											{MainService.getValueByLanguageId(item.names, languageId)}
										</Link>
										<div className="line"></div>
										<span>{MainService.getValueByLanguageId(item.shortDescriptions, languageId)}</span>
									</div>
								}
							})
							: null
					}
				</div>
				<div className="clear"></div>
				{
					pagination && pagination.totalPages > currentPage && !isLoading && exhibitions.length ?
						<div ref={targetRef} style={{ height: '10px', width: "100%" }} />
						: null
				}
				{
					isLoading ?
						<div style={{
							display: "flex",
							justifyContent: "center",
							marginTop: "80px",
							marginBottom: "80px",
						}}>
							<span className="custom-loader"></span>
						</div>
						: null
				}
			</div>

		</div>

	)
}
